import { render, staticRenderFns } from "./reservoir-edit-dialog.vue?vue&type=template&id=ed1ffaec&scoped=true&"
import script from "./reservoir-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./reservoir-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ffaec",
  null
  
)

export default component.exports